
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { FileReferenceModel } from './Entities.GormCrm.FileReference';
import { TaskActionModel } from './Entities.GormCrm.TaskAction';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class TaskAttachmentModel extends Model<TaskAttachmentModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'taskAttachment.property.id', isHidden: true },
		{ name: 'taskActionId', type: 'guid', languageString: 'taskAttachment.property.taskActionId' },
		{ name: 'uploaded', type: 'Date', languageString: 'taskAttachment.property.uploaded' },
		{ name: 'companyId', type: 'guid', languageString: 'taskAttachment.property.companyId' },
		{ name: 'taskflowId', type: 'guid', languageString: 'taskAttachment.property.taskflowId' },
		{ name: 'fileReferenceId', type: 'guid', languageString: 'taskAttachment.property.fileReferenceId' },
		{ name: 'deleted', type: 'Date', languageString: 'taskAttachment.property.deleted', isHidden: true },
		{ name: 'company', type: 'CompanyModel', languageString: 'taskAttachment.property.company', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'fileReference', type: 'FileReferenceModel', languageString: 'taskAttachment.property.fileReference', isHidden: true, isObject: true, new: () => { return new FileReferenceModel }, properties: () => { return FileReferenceModel.classProperties } },
		{ name: 'taskAction', type: 'TaskActionModel', languageString: 'taskAttachment.property.taskAction', isHidden: true, isObject: true, new: () => { return new TaskActionModel }, properties: () => { return TaskActionModel.classProperties } },
		{ name: 'taskflow', type: 'TaskflowModel', languageString: 'taskAttachment.property.taskflow', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public taskActionId?: string;
	public uploaded?: Date;
	public companyId?: string;
	public taskflowId?: string;
	public fileReferenceId?: string;
	public deleted?: Date;
	public company?: CompanyModel;
	public fileReference?: FileReferenceModel;
	public taskAction?: TaskActionModel;
	public taskflow?: TaskflowModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.taskActionId = undefined;
		this.uploaded = undefined;
		this.companyId = undefined;
		this.taskflowId = undefined;
		this.fileReferenceId = undefined;
		this.deleted = undefined;
		this.company = undefined;
		this.fileReference = undefined;
		this.taskAction = undefined;
		this.taskflow = undefined;
		
	}
	getProperties(){
		return TaskAttachmentModel.classProperties;
	}
}

